module.exports = __webpack_public_path__ + "static/media/legend.e3575ed9.svg";